export enum ProcessState {
    INACTIVE = 0,
    EXAM_IN_PROGRESS = 1,
    EXAM_COMPLETE = 2,
    EXAM_COMPLETE_ACK = 3,
    SYM_VISIBLE = 4,
    SYM_TREATED = 5,
    SYM_TREATED_VISIBLE
}